import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Surface } from '..';
import { useTheme } from '@emotion/react';
const RadioButton = (props) => {
    const theme = useTheme();
    return (_jsx(Surface, { as: "input", type: "radio", checked: props.checked, css: {
            appearance: 'none',
            display: 'inline-flex',
            borderRadius: theme.shape.small,
            width: '1.6rem',
            height: '1.6rem',
            ':checked': {
                ':before': {
                    content: '""',
                    display: 'block',
                    margin: 'auto',
                    width: '0.8rem',
                    height: '0.8rem',
                    borderRadius: theme.shape.extraSmall,
                    backgroundColor: theme.color.primary,
                },
            },
        } }));
};
export default RadioButton;
//# sourceMappingURL=RadioButton.js.map